import img1 from "../../assets/foodorder.png"
import img2 from "../../assets/blog.png"
import img3 from "../../assets/keeper.png"
import img4 from "../../assets/jokeapi.png"
import img5 from "../../assets/added.png";
import img6 from "../../assets/roomrental.png";
import img7 from "../../assets/chem.png";
import img8 from "../../assets/as01.png";
import img9 from "../../assets/oauth.png";
import img10 from "../../assets/bsw.png";

const Data =[
    {
        id:8,
        image:img9,
        title:"Oauth For Clubs"
    },
    {
        id:8,
        image:img10,
        title:"Acad Mentor Portal (BSW)"
    },
    {
    id:7,
    image:img8,
    title:"Chat Application",
    },{
    id:0,
    image:img6,
    title:"Full Stack Room Rental App",
},{
    id:6,
    image:img7,
    title:"Reactor X Optimate",
},
{
    id:1,
    image:img1,
    title:"Food Order App",
},{
    id:2,
    image:img2,
    title:"Blog App",
},{
    id:3,
    image:img3,
    title:"Keeper App",
},{
    id:4,
    image:img4,
    title:"Joke App",
},{
    id:5,
    image:img5,
    title:"More to be Added..."
}]
export default Data;

